import { ROLES } from "../constants";

const isAdminOrManager = (userRole) =>
  userRole.includes(ROLES.ADMIN) || userRole.includes(ROLES.MANAGER);

const isAdminManagerOrNutritionist = (userRole) =>
  userRole.includes(ROLES.ADMIN) ||
  userRole.includes(ROLES.MANAGER) ||
  userRole.includes(ROLES.NUTRITIONIST);

const getTitleMenuSettings = (t, userRole) => [
  {
    groupKey: "menu",
    groupLabel: t("settings-group-menu"),
    icon: "ti-salad",
    allowedRoles: isAdminManagerOrNutritionist(userRole),
    items: [
      {
        name: t("settings-menu-title-menuCategories"),
        linkForRoute: "menu-categories",
        allowedRoles: isAdminManagerOrNutritionist(userRole),
      },
      {
        name: t("settings-menu-title-meals"),
        linkForRoute: "meals",
        allowedRoles: isAdminManagerOrNutritionist(userRole),
      },
      {
        name: t("settings-menu-title-diet-mode-and-types"),
        linkForRoute: "diet-mode-and-types",
        allowedRoles: isAdminOrManager(userRole),
      },
    ],
  },
  {
    groupKey: "packs",
    groupLabel: t("settings-group-packs"),
    icon: "ti-package",
    allowedRoles: isAdminOrManager(userRole),
    items: [
      {
        name: t("settings-menu-title-pack-categories"),
        linkForRoute: "pack-categories",
        allowedRoles: isAdminOrManager(userRole),
      },
      {
        name: t("settings-menu-title-packs"),
        linkForRoute: "packs",
        allowedRoles: isAdminOrManager(userRole),
      },
      {
        name: t("settings-menu-title-periods"),
        linkForRoute: "periods",
        allowedRoles: isAdminOrManager(userRole),
      },
    ],
  },
  {
    groupKey: "pricing",
    groupLabel: t("settings-group-pricing"),
    icon: "ti-coin",
    allowedRoles: isAdminOrManager(userRole),
    items: [
      {
        name: t("settings-menu-title-price"),
        linkForRoute: "price",
        allowedRoles: isAdminOrManager(userRole),
      },
      {
        name: t("settings-menu-title-promoCodes"),
        linkForRoute: "promo-codes",
        allowedRoles: isAdminOrManager(userRole),
      },
    ],
  },
  {
    groupKey: "products",
    groupLabel: t("settings-group-products"),
    icon: "ti-box",
    allowedRoles: isAdminManagerOrNutritionist(userRole),
    items: [
      {
        name: t("settings-menu-title-products"),
        linkForRoute: "products",
        allowedRoles: isAdminManagerOrNutritionist(userRole),
      },
      {
        name: t("settings-menu-title-productBrands"),
        linkForRoute: "product-brands",
        allowedRoles: isAdminManagerOrNutritionist(userRole),
      },
      {
        name: t("settings-menu-title-productGroups"),
        linkForRoute: "product-groups",
        allowedRoles: isAdminManagerOrNutritionist(userRole),
      },
    ],
  },
  {
    groupKey: "system",
    groupLabel: t("settings-group-system"),
    icon: "ti-adjustments",
    allowedRoles: isAdminOrManager(userRole),
    items: [
      {
        name: t("settings-menu-title-settings"),
        linkForRoute: "settings",
        allowedRoles: isAdminOrManager(userRole),
      },
      {
        name: t("settings-menu-title-payment-settings"),
        linkForRoute: "payment-settings",
        allowedRoles: isAdminOrManager(userRole),
      },
      {
        name: t("settings-menu-title-client-settings"),
        linkForRoute: "client-settings",
        allowedRoles: isAdminOrManager(userRole),
      },
    ],
  },
];

export { getTitleMenuSettings };
